import React, { useState, useEffect } from 'react';
import UserService from '../service/UserService';
import './UserManagementPage.css'; // Assuming you have a CSS file for styles

const UserManagementPage = () => {
    const [user, setUser] = useState({
        user_id: '',
        name: '',
        email: '',
        city: '',
        username: '',
        userType: 1, // Default user type
        role: '', // Added role
    });

    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchUserDetails = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await UserService.getYourProfile(token);
            console.log("Fetched user details:", response);

            if (response && response.users) {
                setUser({
                    user_id: response.users.user_id,
                    name: response.users.name,
                    email: response.users.email,
                    city: response.users.city,
                    username: response.users.username,
                    userType: response.users.userType || 1, // Default value if not found
                    role: response.users.role || '', // Fetching role
                });
            } else {
                setError('No user details found');
            }
        } catch (error) {
            console.error('Error fetching user details:', error);
            setError('Failed to load user details');
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchUserDetails();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setUser((prevUser) => ({
            ...prevUser,
            [name]: value,
        }));
    };

    const handleSave = async () => {
        try {
            const token = localStorage.getItem('token');
            const updatedUser = {
                ...user,
                userType: user.userType || 1, // Ensure userType is included
            };

            const response = await UserService.updateUser(user.user_id, updatedUser, token);
            alert('Profile updated successfully');
            console.log('Updated profile:', response);
        } catch (error) {
            console.error('Error updating user profile:', error);
            alert('Failed to update profile');
        }
    };

    return (
        <div className="profile-page-container">
            <h2>Edit Profile</h2>
            {isLoading ? (
                <p>Loading user details...</p>
            ) : error ? (
                <p>{error}</p>
            ) : (
                user && user.user_id ? (
                    <div className="table-container">
                        <table className="profile-table">
                            <tbody>
                                <tr>
                                    <td>ID:</td>
                                    <td><input type="text" name="user_id" value={user.user_id} disabled /></td>
                                </tr>
                                <tr>
                                    <td>Name:</td>
                                    <td><input type="text" name="name" value={user.name} onChange={handleChange} /></td>
                                </tr>
                                <tr>
                                    <td>Email:</td>
                                    <td><input type="text" name="email" value={user.email} onChange={handleChange} /></td>
                                </tr>
                                <tr>
                                    <td>City:</td>
                                    <td><input type="text" name="city" value={user.city} onChange={handleChange} /></td>
                                </tr>
                                <tr>
                                    <td>Username:</td>
                                    <td><input type="text" name="username" value={user.username} onChange={handleChange} /></td>
                                </tr>
                                <tr>
                                    <td>User Type:</td>
                                    <td><input type="number" name="userType" value={user.userType} onChange={handleChange} /></td>
                                </tr>
                                <tr>
                                    <td>Role:</td>
                                    <td><input type="text" name="role" value={user.role} onChange={handleChange} /></td>
                                </tr>
                            </tbody>
                        </table>
                        <button type="button" onClick={handleSave}>Save</button>
                    </div>
                ) : (
                    <p>No user details found</p>
                )
            )}
        </div>
    );
};

export default UserManagementPage;
